import * as t from 'io-ts';

export const quotingNotesDynamicType = t.interface({
    quoteIntroduction: t.union([t.string, t.null]),
    htmlQuoteIntroduction: t.union([t.string, t.null]),
    notes: t.union([t.string, t.null]),
    htmlNotes: t.union([t.string, t.null]),
    additionalInformation: t.union([t.string, t.null]),
    htmlAdditionalInformation: t.union([t.string, t.null]),
    termsAndConditions: t.union([t.string, t.null]),
    htmlTermsAndConditions: t.union([t.string, t.null]),
    customerNotes: t.union([t.string, t.null]),
    htmlCustomerNotes: t.union([t.string, t.null]),
    htmlQuoteSubjectTo: t.union([t.string, t.null]),
    htmlPaymentTerms: t.union([t.string, t.null]),
    htmlGoNowExcludes: t.union([t.string, t.null]),
});

export type QuotingNotes = t.TypeOf<typeof quotingNotesDynamicType>;
